import React, { useState, useEffect } from "react";
import "./CreateSpecialityModal.css";
import * as Yup from "yup";
import Form from "../../form/components/Form/Form";
import FormField from "../../form/components/FormField/FormField";
import Button from "../../form/components/Button/Button";
import ErrorMessage from "../../form/components/ErrorMessage/ErrorMessage";
import { ImCancelCircle } from "react-icons/im";
import { toast } from "react-toastify";
import BeatLoader from "react-spinners/BeatLoader";

import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

import firebase from 'firebase/app';

import { collection, addDoc, query, getDocs, where, serverTimestamp  } from "firebase/firestore";
import { db } from "../../../firebase/firebase-config";

const initialValues = {
  speciality_name: "",
};

const override = {
  marginTop: "20px",
};

function CreateSpecialityModal({ onClose, onContentAdded }: any) {
  
  const [error, setError] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    speciality_name: Yup.string().required("Speciality Name is required"),
  });

  const handleAddSpeciality = async (values: any) => {
    setError(null);

    setLoading(true);

    const reqData: any = {
      ...values,
      speciality_value: values?.speciality_name.split(' ').join('_').toLowerCase(),
      createdAt: serverTimestamp()
    }

try {
    //CHECK  IF SPECIALITY  ALREADY EXIST
    const q = query(collection(db, "Specialities"), where("speciality_name", "==", reqData?.speciality_name));

    const querySnapshot = await getDocs(q);

    if(querySnapshot.size > 0) {
      // alert already exists
      toast.error("SPECIALITY  ALREADY EXIST", {
        pauseOnHover: false,
        closeOnClick: true,
      })
      return;
    }

    const docRef = collection(db,"Specialities")
    
    await addDoc(docRef, reqData);

    setLoading(false);
    onContentAdded();
    onClose();
    toast.success('Speciality Added', {
      pauseOnHover: false,
      closeOnClick: true,
    })

  } catch (error) {
    toast.error("Error", {
      pauseOnHover: false,
      closeOnClick: true,
    })
  }
};

  return (
    <>
    <div>
      <div className="modal-container" id='create-speciality-modal'>
        <div className="modal-head">
          <p className="modal-title">Add New Speciality</p>
          <ImCancelCircle
            style={{ cursor: "pointer" }}
            onClick={onClose}
            size={22}
            color="#fff"
          />
        </div>
        <div className="modal-content">
          <div style={{ textAlign: "center", marginBottom: "10px" }}>
            <BeatLoader
              color="#3080ED"
              loading={loading}
              cssOverride={override}
            />
          </div>
          <form action="" className="auth-form">
            {error && <ErrorMessage error={error} visible={true} />}
            <Form
              initialValues={initialValues}
              onSubmit={handleAddSpeciality}
              validationSchema={validationSchema}
            >
              <p className="label-text">Speciality: </p>
              <FormField name="speciality_name" type="text" placeholder="Speciality" />

              {!loading && (
                <Button
                  isOutLined={true}
                  isFullWidth={false}
                  title="CREATE SPECIALITY"
                />
              )}
            </Form>
          </form>
        </div>
      </div>
      <div className="modal-shadow" onClick={onClose}></div>
    </div>
    </>
  );
}

export default CreateSpecialityModal;
